import { useTranslation } from 'react-i18next';
import { HStack, VStack } from 'native-base';

import { selectUserProfile } from '@app/store/selectors';
import { useAppSelector } from '@app/store/store';
import { Button, Modal, Text } from '@pimm/base';
import { formatName } from '@app/utils/string-formatter';

type PinAccessModalProps = {
  isOpen: boolean;
  onClose?: () => void;
  onUnlock?: () => void;
};

export const PinAccessModal = ({ isOpen, onClose, onUnlock }: PinAccessModalProps) => {
  const { t } = useTranslation();
  const user = useAppSelector(selectUserProfile);

  const handleSelectEmployeeClose = () => {
    if (onClose) onClose();
  };

  const handlePressUnlock = () => {
    if (onUnlock) onUnlock();
  };

  return (
    <Modal hideClose noPadding isOpen={isOpen} onClose={onClose} size="md" _content={{ rounded: 'xl', p: 5, maxW: 400 }}>
      <VStack space={2}>
        <Text size="lg" color="gray.900" fontWeight={700}>
          {t('store_core:pin_access_required')}
        </Text>
        <Text size="md" color="gray.600" fontWeight={400}>
          {t('store_core:shared_account_message', {
            userName: formatName(user.firstName, user.lastName),
          })}
        </Text>
        <Text size="md" color="gray.900" fontWeight={700} pt={1}>
          {t('store_core:manager_unlock_header')}
        </Text>
        <Text size="md" color="gray.600" fontWeight={400}>
          {t('store_core:manager_unlock_steps')}
        </Text>
        <HStack space={2} pt={5}>
          <Button flex={1} size="lg" variant="unstyled" borderColor="gray.300" bg="white" shadow={1} onPress={onClose}>
            {t('store_core:cancel')}
          </Button>
          <Button flex={1} size="lg" shadow={0} onPress={handlePressUnlock}>
            {t('store_core:unlock')}
          </Button>
        </HStack>
      </VStack>
    </Modal>
  );
};
